import { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";

// hooks
import { gql, useMutation } from "@apollo/client";

// components
import { Alert, Snackbar, Grid, TextField, Button } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";

import Layout from "../../components/Layout";
import Loader from "../../common/loader";

import useMe from "../../common/hooks/useMe";

const SAVE_USER = gql`
  mutation saveUser($first: String, $last: String) {
    saveUser(first: $first, last: $last)
  }
`;

const Profile = () => {
  const { loading: userIsLoading } = useAuth0();
  const { me, setMe } = useMe();

  const [saveUserMutation, { loading: loadingSave, error: errorSave }] =
    useMutation(SAVE_USER);

  const [first, setFirst] = useState("");
  const [last, setLast] = useState("");
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState("info");
  const [alertMessage, setAlertMessage] = useState("");

  useEffect(() => {
    if (!first) setFirst(me?.firstName);
    if (!first) setLast(me?.lastName);
  }, [first, me?.firstName, me?.lastName]);

  const saveUser = () => {
    saveUserMutation({
      variables: { first, last },
    })
      .then(() => {
        setMe({ ...me, firstName: first, lastName: last });
        setAlertMessage("Sačuvano.");
        setAlertSeverity("success");
      })
      .catch((err) => {
        let msg = err.message;
        if (errorSave) msg = errorSave.message;
        setAlertMessage(`Čuvanje nije uspelo. ${msg}`);
        setAlertSeverity("error");
      })
      .finally(() => setAlertOpen(true));
  };

  if (loadingSave || !me) return <Loader />;

  if (errorSave) {
    const message = errorSave?.message;

    setAlertMessage(message || "ERROR");
    setAlertSeverity("error");
    setAlertOpen(true);
  }

  const anchor = { vertical: "top", horizontal: "center" };

  const submitForm = (e) => {
    e.preventDefault();
    saveUser();
  };

  return (
    <Layout title="Moj Profil">
      {userIsLoading && <>loading</>}
      {!userIsLoading && (
        <form onSubmit={submitForm}>
          <Snackbar
            open={alertOpen}
            autoHideDuration={3000}
            anchorOrigin={anchor}
          >
            <Alert onClose={() => setAlertOpen(false)} severity={alertSeverity}>
              {alertMessage}
            </Alert>
          </Snackbar>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TextField label="E-Mail" value={me.email} fullWidth disabled />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Ime"
                value={first}
                onChange={(e) => setFirst(e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Prezime"
                value={last}
                onChange={(e) => setLast(e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} style={{ textAlign: "right" }}>
              <Button
                variant="contained"
                color="secondary"
                startIcon={<SaveIcon />}
                type="submit"
              >
                Sačuvaj
              </Button>
            </Grid>
          </Grid>
        </form>
      )}
    </Layout>
  );
};

export default Profile;
